
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
    layout(context) {
        return context.$auth.loggedIn ? 'authenticated' : 'default'
    },
})
